import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'
import { t } from '@/lib/i18n'

export default function ResetPassword({ token }: { token: string }) {
  const form = useForm({ password: '', password_confirmation: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch(`/passwords/${token}`)
  }

  return (
    <AuthShell title={t('auth.reset_password.title')} subtitle={t('auth.reset_password.subtitle')}>
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label={t('auth.reset_password.new_password')}
          type="password"
          autoComplete="new-password"
          autoFocus
          required
          maxLength={72}
          placeholder={t('auth.min_length')}
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <Field
          label={t('auth.reset_password.confirm_new')}
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          value={form.data.password_confirmation}
          error={form.errors.password_confirmation}
          onChange={(e) => form.setData('password_confirmation', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? t('auth.reset_password.submitting') : t('auth.reset_password.title')}</SubmitButton>
      </form>
    </AuthShell>
  )
}
